import { isPeopleModuleEnabled } from '@office-start/ai-hub-config-service';
export var peopleRouteGuard = function (props) {
    var canActivate = isPeopleModuleEnabled(props.featureGates);
    return { canActivate: canActivate };
};
//# sourceMappingURL=peopleRouteGuard.js.map